import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Box, Flex } from '@latitude/box';
import { Heading3 } from '@latitude/heading';
import { ALIGN, COLOR, ALIGN_ITEMS } from '@latitude/core/utils/constants';
const List = /*#__PURE__*/styled.ol.withConfig({
  displayName: "ListNumbered__List",
  componentId: "sc-1wy9xei-0"
})(["list-style-type:none;margin:0;padding:", ";"], _ref => {
  let {
    listPadding
  } = _ref;
  return listPadding || '0';
});
const ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "ListNumbered__ListItem",
  componentId: "sc-1wy9xei-1"
})(["display:flex;align-items:", ";counter-increment:list-num;min-height:70px;font-weight:300;margin:0;padding:", ";line-height:22px;color:", ";text-align:left;", ";:first-child{", "}:nth-last-child(1){", ";}:before{content:counter(list-num);display:block;position:relative;left:-16px;height:30px;width:30px;min-width:30px;background:", ";border-radius:100%;font-size:14px;line-height:30px;font-weight:bold;text-align:center;color:", ";}"], _ref2 => {
  let {
    counterVerticalAlign
  } = _ref2;
  return `
    ${counterVerticalAlign}
  `;
}, _ref3 => {
  let {
    listItemPadding
  } = _ref3;
  return listItemPadding || '10px 0 10px 16px';
}, COLOR.BODY, _ref4 => {
  let {
    separator
  } = _ref4;
  switch (separator) {
    case 'none':
      return '';
    case 'light':
      return `border-top: 1px solid #e5e5e5`;
    case 'standard':
    default:
      return `border-top: 1px solid #979797;`;
  }
}, _ref5 => {
  let {
    separator
  } = _ref5;
  if (separator !== 'light') {
    return '';
  }
  return `border-top-style: none;`;
}, _ref6 => {
  let {
    separator
  } = _ref6;
  return separator === 'standard' ? `border-bottom: 1px solid #979797;` : '';
}, _ref7 => {
  let {
    counterBgColor
  } = _ref7;
  return counterBgColor;
}, COLOR.WHITE);
const ListNumbered = props => {
  const {
    className,
    title,
    data,
    children,
    separator = 'standard',
    listPadding,
    listItemPadding,
    counterBgColor = COLOR.BLUE,
    counterVerticalAlign = ALIGN_ITEMS.CENTER
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    className: classnames(`list-numbered`, {
      className
    })
  }, title && /*#__PURE__*/React.createElement(Heading3, {
    align: ALIGN.CENTER,
    color: COLOR.BLUE
  }, title), props.data && /*#__PURE__*/React.createElement(List, null, data.map((item, i) => /*#__PURE__*/React.createElement(ListItem, {
    key: i,
    separator: separator,
    counterBgColor: counterBgColor,
    counterVerticalAlign: counterVerticalAlign,
    listPadding: listPadding,
    listItemPadding: listItemPadding
  }, /*#__PURE__*/React.createElement(Flex, {
    align: ALIGN.CENTER
  }, ReactHtmlParser(item))))), children);
};
export default ListNumbered;